var map = {
	"./arrow_down.svg": "5490",
	"./auctions.svg": "c033",
	"./avisos.svg": "b7fc",
	"./buscar.svg": "f3b9",
	"./cancel.svg": "50d5",
	"./capturas.svg": "0f15",
	"./check.svg": "96f0",
	"./clock.svg": "a1a1",
	"./close.svg": "0712",
	"./comment-sms-solid.svg": "604a",
	"./documents.svg": "0011",
	"./edit_check.svg": "e4fe",
	"./edit_close.svg": "f4d5",
	"./efforts.svg": "dd4c",
	"./especies.svg": "4a70",
	"./excel.png": "2074",
	"./expirations.svg": "f04c",
	"./fempa_white_logo.png": "071d",
	"./file.png": "bbff",
	"./forbidden.svg": "f6fb",
	"./gas_meter.svg": "ef12",
	"./gas_station.svg": "a546",
	"./img.png": "fa5d",
	"./left-arrow.png": "e0cf",
	"./lunar_phases/cuarto creciente.png": "d001",
	"./lunar_phases/cuarto creciente.svg": "a769",
	"./lunar_phases/cuarto menguante.png": "b538",
	"./lunar_phases/cuarto menguante.svg": "be9f",
	"./lunar_phases/luna creciente.png": "e675",
	"./lunar_phases/luna creciente.svg": "c0bc",
	"./lunar_phases/luna gibosa creciente.png": "f5b4",
	"./lunar_phases/luna gibosa creciente.svg": "747f",
	"./lunar_phases/luna gibosa menguante.png": "5d0f",
	"./lunar_phases/luna gibosa menguante.svg": "46dd",
	"./lunar_phases/luna llena.png": "0f12",
	"./lunar_phases/luna llena.svg": "9d16",
	"./lunar_phases/luna menguante.png": "63f8",
	"./lunar_phases/luna menguante.svg": "b46f",
	"./lunar_phases/luna nueva.png": "dc27",
	"./lunar_phases/luna nueva.svg": "5d02",
	"./mapas.svg": "887e",
	"./menu_icon.svg": "cfdf",
	"./minus.svg": "56b6",
	"./pdf.png": "06ee",
	"./plus.svg": "b2b2",
	"./quotas.svg": "2f44",
	"./sales.svg": "8b6c",
	"./seatides.svg": "eae3",
	"./show_more.png": "5ebc",
	"./stadistic_bars.svg": "8195",
	"./tallas.svg": "9354",
	"./tide_indicator.svg": "aacd",
	"./user.svg": "3f03",
	"./whatsapp.svg": "8656",
	"./word.png": "e458",
	"./xunta_white_logo.png": "126a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0520";